const LK_Delete =({color,width,height,id})=>{
    return(
        <svg id="Layer_1" fill={color} data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 116.99 116.99">
        {/* <defs>
          <style>
            .cls-1 {
              fill: #005c8e;
              stroke-width: 0px;
            }
          </style>
        </defs> */}
        <path class="cls-1" d="M68.99,20.99v4h27v12h-9v59h-46.5c-5.79,0-10.5-4.71-10.5-10.5v-48.5h-9v-12h27v-4h21M71.99,17.99h-27v4h-27v18h9v45.5c0,7.46,6.04,13.5,13.5,13.5h49.5v-59h9v-18h-27v-4h0ZM43.49,39.99v44h-3v-44h3M46.49,36.99h-9v50h9v-50h0ZM59.99,39.99v44h-3v-44h3M62.99,36.99h-9v50h9v-50h0ZM76.49,39.99v44h-3v-44h3M79.49,36.99h-9v50h9v-50h0Z"/>
      </svg>
    );
};

export default LK_Delete;